import { createSlice, createSelector } from '@reduxjs/toolkit';

// HassEntity shape is whatever Home Assistant returns from /api/states
// We store entities keyed by entity_id for efficient updates
const initialState = {
  connected: false,
  authStatus: 'pending', // 'pending' | 'ok' | 'failed'
  entities: {}, // { [entity_id]: HassEntity }
};

const hassioSlice = createSlice({
  name: 'hassio',
  initialState,
  reducers: {
    setConnected(state, action) {
      state.connected = Boolean(action.payload);
    },
    setAuthStatus(state, action) {
      state.authStatus = action.payload;
    },
    updateEntity(state, action) {
      const entity = action.payload;
      if (entity && entity.entity_id) {
        state.entities[entity.entity_id] = entity;
      }
    },
    updateEntities(state, action) {
      const entitiesObj = action.payload || {};
      // Allow passing an array from /api/states directly
      if (Array.isArray(entitiesObj)) {
        entitiesObj.forEach((ent) => {
          if (ent && ent.entity_id) {
            state.entities[ent.entity_id] = ent;
          }
        });
        return;
      }
      Object.keys(entitiesObj).forEach((id) => {
        const ent = entitiesObj[id];
        if (ent && ent.entity_id) {
          state.entities[ent.entity_id] = ent;
        }
      });
    },
    removeEntity(state, action) {
      const id = action.payload;
      if (id && state.entities[id]) {
        delete state.entities[id];
      }
    },
  },
});

export const {
  setConnected,
  setAuthStatus,
  updateEntity,
  updateEntities,
  removeEntity,
} = hassioSlice.actions;

// Selectors
export const selectConnected = (state) => state.hassio.connected;
export const selectAuthStatus = (state) => state.hassio.authStatus;
export const selectEntity = (entityId) => (state) => state.hassio.entities[entityId];

export const selectEntitiesByDomain = (domain) =>
  createSelector(
    (state) => state.hassio.entities,
    (entities) => {
      const result = {};
      Object.keys(entities).forEach((id) => {
        if (id.startsWith(`${domain}.`)) {
          result[id] = entities[id];
        }
      });
      return result;
    }
  );

export default hassioSlice.reducer;


